import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { SharedModule } from '@app/shared/shared.module';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'slotcom-premium-pass-reward',
  templateUrl: './premium-pass-reward.component.html',
  styleUrls: ['./premium-pass-reward.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule],
})
export class PremiumPassRewardModalComponent implements OnInit {
  premiumPassRewardModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  private translateService = inject(TranslateService);

  buttonText: string;

  ngOnInit(): void {
    this.setButtonText();
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.premiumPassRewardModalData.id, ModalType.Persisted, this.premiumPassRewardModalData)
    );
  }

  private setButtonText(): void {
    const propertiesButtonText =
      this.premiumPassRewardModalData.properties.buttonText[this.translateService.currentLang];

    this.buttonText = propertiesButtonText ? propertiesButtonText : this.translateService.instant('home.buttons.great');
  }
}
